module.exports = __webpack_public_path__ + "static/img/xdt-code.af49671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xdt-code.png
// module id = TWz1
// module chunks = 10